import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/default/speed.js
const SpeedIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", { d: "M9 18q-.213 0-.424-.012h.85Q9.214 18 9 18M9 2a8 8 0 0 1 8 8c0 1.975-.719 3.78-1.905 5.175a.75.75 0 0 1-1.204.018l-1.509-1.971a.75.75 0 0 1 .596-1.206h1.674a6 6 0 1 0-11.304 0h1.68a.75.75 0 0 1 .596 1.206l-1.507 1.971a.75.75 0 0 1-1.133.07l-.003.004A8 8 0 0 1 9 2" }),
		/* @__PURE__ */ jsx("rect", {
			width: 6,
			height: 2,
			x: 6,
			y: 14,
			fillOpacity: .5,
			rx: 1
		}),
		/* @__PURE__ */ jsx("path", { d: "M8.3 6.318c.246-.64 1.154-.64 1.4 0L10.732 9h-.002a2 2 0 1 1-3.46 0h-.001z" }),
		/* @__PURE__ */ jsxs("g", {
			fillOpacity: .5,
			children: [
				/* @__PURE__ */ jsx("circle", {
					cx: 5,
					cy: 10.25,
					r: .75
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 13,
					cy: 10.25,
					r: .75
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 6,
					cy: 7.25,
					r: .75
				}),
				/* @__PURE__ */ jsx("circle", {
					cx: 12,
					cy: 7.25,
					r: .75
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SpeedIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=speed.js.map